<div class="panel panel-primary panel-danger" data-testid="picket-signout-page">
  <div class="panel-heading clearfix">
    <h4 class="panel-title pull-left" style="padding-top: 0px; padding-bottom: 0px" data-testid="picket-signout-header">
      {{ picketName }} Sign-Out : {{ currentTime | date: "medium" }}
    </h4>
  </div>
  <div class="panel-body">
    <form class="form-horizontal" role="form">
      <div class="col-md-6 col-xs-12 pull-left">
        <div class="row">
          <div class="input-group input-group-sm col-xs-12 col-sm-12 col-md-12">
            <label for="inputSearchMembers" class="control-label">Scan Member Card here ...</label>
            <input id="inputSearchMembers" name="inputId" strikeAutoFocus type="search"
              [(ngModel)]="filterMember" class="form-control shortInputSearch" placeholder="Filter.."
              (keyup.enter)="searchMbr()" data-testid="picket-signout-input"/>
            <div class="input-group-btn">
              <button class="btn btn-primary" (click)="searchMbr()" data-testid="picket-signout-search-button">
                <i class="glyphicon glyphicon-search"></i>
              </button>
              <button class="btn btn-primary" (click)="clearSearchMbr()" data-testid="picket-signout-clear-button">
                <i class="glyphicon glyphicon-remove-sign"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-xs-12 col-sm-12 pull-right" *ngIf="member.MemberId" data-testid="picket-signout-member-info">
            <h4>
              {{
              member.LastName +
              ", " +
              member.FirstName +
              " " +
              member.MiddleName
              }}
            </h4>
            <br />
            <div *ngIf="existingSignIn.MemberId">
              <div class="col-xs-6 col-sm-6 alert alert-success">
                <span class="control-label">Sign-In Time</span>
                <br />
                <h4>
                  {{
                  existingSignIn.SignInTime | date: "MM/dd/yyyy 'at' h:mma"
                  }}
                </h4>
              </div>
              <div class="col-xs-5 col-sm-5 pull-right">
                <button type="button" style="width: 100%; height: 100%" class="btn btn-primary"
                  (click)="addSignOutPicketline()" [disabled]="!(existingSignIn.MemberId.length > 0)"
                  data-testid="picket-signout-button">
                  Sign-Out
                </button>
              </div>
            </div>
            <div class="row alert alert-danger" *ngIf="displayNotYetSignedMessage"
              data-testid="picket-signout-not-signed-in">
              <div class="col-xs-12 col-sm-12 col-md-12" style="text-align: center">
                <h4 class="color:red">Not yet Signed-in!!!</h4>
                <!--<h4>on</h4>-->
                <h4>{{ notYetSignedMessage }}</h4>
                <br />
              </div>
            </div>
          </div>
        </div>
        <div class="pull-left" data-testid="picket-signout-back-to-strike">
          <a [routerLink]="['/strikes/', strikeId]">Back to Strike </a>
        </div>
      </div>

      <div class="col-md-6 col-xs-12 pull-right">
        <div class="alert alert-danger">
          <span class="control-label">Last Sign-Out </span>
        </div>

        <div class="table-responsive" [hidden]="lastSignedOutMembers.length <= 0">
          <table class="table table-striped table-condensed">
            <thead>
              <tr>
                <th>SlNo</th>
                <th>SignOut</th>
                <th>SignIn</th>
                <th>ID</th>
                <th>Name</th>
                <th>Duration</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="
                  let signedOutMember of lastSignedOutMembers | slice: 0 : 4
                ">
                <td data-testid="signout-no">{{ signedOutMember.SlNo }}</td>
                <td>{{ signedOutMember.SignOut | date: "h:mma" }}</td>
                <td>{{ signedOutMember.SignIn | date: "h:mma" }}</td>
                <td>
                  <div *ngIf="signedOutMember.ImageExists">
                    <img class="thumbnail" width="75px" height="50px" src="Content/images/members/{{
                        signedOutMember.MemberId
                      }}.jpg" alt="{{ signedOutMember.MemberId }}" />
                    <br />
                    {{ signedOutMember.MemberId }}
                  </div>
                  <div *ngIf="!signedOutMember.ImageExists">
                    {{ signedOutMember.MemberId }}
                  </div>
                </td>
                <td [attr.data-testid]="'signout-name-' + signedOutMember.MemberId">
                  {{
                  signedOutMember.LastName +
                  " " +
                  signedOutMember.MiddleName +
                  " " +
                  signedOutMember.FirstName
                  }}
                </td>
                <td>
                  {{
                  signedOutMember.Hours +
                  " hrs " +
                  signedOutMember.Minutes +
                  " min."
                  }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>
  <div class="panel-footer clearfix"></div>
</div>
